// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
// eslint-disable-next-line import/no-extraneous-dependencies
import Element from 'element-ui';

import './baseline.css';
import Layout from 'components/Layout';
import VssCard from 'components/VssCard';
import validate from 'utils/validate';
import componentCore from 'libs/componentCore';
import VueCompositionAPI from '@vue/composition-api';
import { mixin } from 'utils';

// mcfe组件库及其依赖
import '@mcfe/mcfe-components/lib/theme2/index.css';
import '@bfe/mtd-theme-582/index.css';
import MTD from '@ss/mtd-vue';
import mcfe from '@mcfe/mcfe-components';
import BizSupplyNetwork from '@mcfe/biz-supply-network';

import { reportMetric } from 'utils/reportMetric';

import methodsPlugin from '../globalMethod/methodsPlugin';
import servicePlugin from '../services/servicePlugin';


import './vssSearchStyle.scss';


Vue.prototype.$EventBus = new Vue();

// 暂时按需引入项目中使用的mcfe组件所需的MTD组件。
Vue.use(mcfe);
Vue.use(MTD);
Vue.use(BizSupplyNetwork);

Vue.use(VueCompositionAPI);
Vue.use(Element);
Vue.use(mixin);
Vue.component('Layout', Layout);
Vue.component('XxLayout', Layout);
Vue.component('McLayout', Layout);
Vue.component('VssCard', VssCard);


Vue.use(componentCore);
Vue.use(methodsPlugin);
Vue.use(validate);
Vue.use(servicePlugin);


// 判断是否是需要上报错误的页面
function isSelectProductPage() {
    const currentUrl = window.location.pathname || window.location.href;
    // 需要上报错误的页面列表
    const errorReportPages = [
        '/grocery/product/createNewProduct/detail.html',
        '/grocery/product/createNewProduct/add.html',
        '/grocery/product/createNewProduct/operateContentDetail.html',
    ];
    return errorReportPages.some((path) => currentUrl.includes(path));
}

// 获取页面类型
function getPageType() {
    const currentUrl = window.location.pathname || window.location.href;

    // 定义页面类型映射
    const pageTypeMap = [
        { path: '/grocery/product/createNewProduct/detail.html', type: '建品' },
        { path: '/grocery/product/createNewProduct/add.html', type: '建品' },
        { path: '/grocery/product/createNewProduct/operateContentDetail.html', type: '信息和图文' },
    ];

    // 查找匹配的页面类型
    const matchedPage = pageTypeMap.find((item) => currentUrl.includes(item.path));
    return matchedPage ? matchedPage.type : '未知页面';
}

// 错误上报函数
function reportError(errorMessage, errorType) {
    if (isSelectProductPage() && errorMessage) {
        reportMetric('vss_global_error_interception_product_creation_maintenance', 1, {
            errorMessage,
            errorType,
            pageType: getPageType(),
        });
    }
}

// 拦截错误方法的通用函数
function interceptErrorMethod(originalMethod, errorType) {
    return function (options) {
        const errorMessage = typeof options === 'string' ? options : (options?.message || '');
        // 检查是否是后端报错（已经在 $xxApiError 中上报过了）
        const isFromBackendError = typeof options === 'object' && options && options._fromBackendError;

        if (!isFromBackendError) {
            // 上报错误（前端报错）
            reportError(errorMessage, errorType);
        }
        // 调用原始方法
        return originalMethod.call(this, options);
    };
}

// 拦截 $message 主函数，处理 message({ type: 'error' })
function interceptMessageMainFunction(originalMessage, errorType) {
    return function (options) {
        // 检查是否是错误类型 $message({ type: 'error', message: 'xxx' })
        const isError = typeof options === 'object' && options && options.type === 'error';
        // 检查是否是后端报错（已经在 $xxApiError 中上报过了）
        const isFromBackendError = isError && options._fromBackendError;

        if (isError && !isFromBackendError) {
            const errorMessage = options.message || '';
            // 上报错误（前端报错）
            reportError(errorMessage, errorType);
        }
        // 调用原始方法
        return originalMessage.call(this, options);
    };
}

// 在 Vue 原型上拦截错误方法
function setupPrototypeInterception() {
    // 只在建品页面时进行拦截
    if (!isSelectProductPage()) {
        return;
    }
    // 先拦截$message 主函数
    if (Vue.prototype.$message && !Vue.prototype.$message._isIntercepted) {
        const originalMessage = Vue.prototype.$message;
        const interceptedMessage = interceptMessageMainFunction(originalMessage, '前端报错');
        interceptedMessage._isIntercepted = true;
        // 复制 originalMessage 上的所有属性（包括 error, success, warning, info 等）
        Object.keys(originalMessage).forEach((key) => {
            if (key !== '_isIntercepted') {
                interceptedMessage[key] = originalMessage[key];
            }
        });
        Vue.prototype.$message = interceptedMessage;
    }

    // 再拦截 $message.error 方法
    if (Vue.prototype.$message && Vue.prototype.$message.error && !Vue.prototype.$message.error._isIntercepted) {
        // 注意：这里需要使用拦截后的主函数上的 error 方法，或者原始 error 方法
        // 由于 error 方法可能内部调用主函数，我们需要拦截它
        const originalMessageError = Vue.prototype.$message.error;
        Vue.prototype.$message.error = interceptErrorMethod(originalMessageError, '前端报错');
        Vue.prototype.$message.error._isIntercepted = true;
    }

    // 拦截 $mc.message.error和$mtd.message.error
    if (Vue.prototype.$mc && Vue.prototype.$mc.message && Vue.prototype.$mc.message.error && !Vue.prototype.$mc.message.error._isIntercepted) {
        const originalMtdMessageError = Vue.prototype.$mc.message.error;
        Vue.prototype.$mc.message.error = interceptErrorMethod(originalMtdMessageError, '前端报错');
        Vue.prototype.$mc.message.error._isIntercepted = true;
    }
}
// 在组件库挂载完成后，设置原型方法拦截
setupPrototypeInterception();

const $xxApiError = (e, customFn = (v) => v) => {
    const message = e && customFn((e.msg || e.message) || '系统请求异常');
    // 如果是建品页面，增加埋点上报
    if (isSelectProductPage()) {
        reportMetric('global_error_interception_product_creation_maintenance', 1, {
            errorMessage: message,
            errorType: '后端报错',
            pageType: getPageType(),
        });
    }
    Vue.prototype.$message.error({
        message,
        _fromBackendError: true, // 标记这是后端报错，已在 $xxApiError 中上报过，避免重复上报
    });
};

window.$xxApiError = $xxApiError;
Vue.prototype.$xxApiError = $xxApiError;


window.__requestErrorCallback = (e) => $xxApiError(e);
Vue.prototype.$s3Path = 'https://s3plus.meituan.net/v1/mss_915cfe67c99b4651b81ca210670f9302/mall-fe-files/';
